module.exports = __webpack_public_path__ + "static/img/tutoriales sin texto utopie-11.e2f4a129.jpg";